import img404 from '../assets/error.png';

const NotFoundPage = () => {

  return (
    <div className="container mx-auto p-4 flex flex-col items-center">
      <img src={img404} alt="404" className="w-3/2" />
      <h2 className="text-xl font-semibold mb-4">Страница не найдена</h2>
      <div>Извините, запрашиваемая страница не найдена.</div>
    </div>
  );
};

export default NotFoundPage;